import s from '../QuestionAndAnswer.module.scss';

const UnAnswered: React.FC = () => (
  <div className={s.answer}>
    <p className='body-sm' style={{ opacity: 0.5 }}>Not Answered</p>
  </div>
);

export default UnAnswered;